import * as React from "react";
const SvgSave = props => <svg width="1em" height="1em" viewBox="0 0 14 10" fill="#0046FF" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.352 1.352 5 9.71.648 5.35l.704-.703L5 8.29 12.648.65l.704.703Z" /></svg>;
export default SvgSave;